import { render } from "./areatype.vue?vue&type=template&id=2031de52&scoped=true&ts=true"
import script from "./areatype.vue?vue&type=script&lang=ts"
export * from "./areatype.vue?vue&type=script&lang=ts"

import "./areatype.vue?vue&type=style&index=0&id=2031de52&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2031de52"]])

export default __exports__